export default function GoogleIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M3.05464 6.25817C3.74798 4.87754 4.81161 3.71693 6.12666 2.90606C7.44171 2.09519 8.95636 1.66602 10.5013 1.6665C12.7471 1.6665 14.6338 2.4915 16.0763 3.83734L13.6871 6.22734C12.823 5.4015 11.7246 4.98067 10.5013 4.98067C8.33047 4.98067 6.49297 6.44734 5.8388 8.4165C5.67214 8.9165 5.57714 9.44984 5.57714 9.99984C5.57714 10.5498 5.67214 11.0832 5.8388 11.5832C6.4938 13.5532 8.33047 15.019 10.5013 15.019C11.6221 15.019 12.5763 14.7232 13.323 14.2232C13.7558 13.9382 14.1264 13.5684 14.4123 13.1361C14.6982 12.7038 14.8935 12.2181 14.9863 11.7082H10.5013V8.48484H18.3496C18.448 9.02984 18.5013 9.59817 18.5013 10.189C18.5013 12.7273 17.593 14.864 16.0163 16.314C14.638 17.5873 12.7513 18.3332 10.5013 18.3332C9.40683 18.3336 8.323 18.1184 7.31176 17.6997C6.30051 17.2811 5.38168 16.6673 4.60777 15.8934C3.83386 15.1195 3.22005 14.2006 2.80141 13.1894C2.38278 12.1781 2.16753 11.0943 2.16797 9.99984C2.16797 8.65484 2.48964 7.38317 3.05464 6.25817Z"
        fill={props.fill || "#0F1324"}
        fillOpacity="0.6"
      />
    </svg>
  );
}
